import { roundups } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

export default function Roundups() {
  return (
    <section id="roundups" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="专题盘点"
          title="值得反复收藏的专题合集"
          desc="入坑指南、治愈盘点、年度口碑，我们用专题形式把优质内容打包整理，一次看个够。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {roundups.map((r) => (
            <a
              key={r.id}
              href="#reviews"
              className="group relative flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/80 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-52">
                <img
                  src={r.image}
                  alt={`${r.title}专题封面`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-900">
                  {r.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-foreground-900">{r.title}</h3>
                  <span className="shrink-0 rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-bold text-primary-700 whitespace-nowrap">
                    {r.count} 部精选
                  </span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                  展开盘点
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}